/**
 * Copyright (c) 2024, Mohamed eRrais (merrais / MeR)
 * mohamed@errais.net
 * https://ocr.1ai.ma, https://akademy.ma, https://digitalservices.ma, https://sites.errais.net, https://2us.ma, https://moshaf.akademy.ma
 * محمد الرايس
 * Rais Digital Services
 * 240704 2333 : From ToTable tajwyd.akademy.ma
 * + from Database.php GetResponse
**/

import React, {useState, useEffect, useLayoutEffect} from 'react'
import {Button} from 'react-bootstrap'
import './meTable.css'
import Api, {Read,Fetch} from '../Shared/Api'
import {icons} from '../Config/app'
import {ToFormat} from  'fast_inon'
import {meResults} from '../Shared/meGlobal'
import {ColorsOptions} from '../Shared/ColorsControl'

const TableView = ({entity, onChange, onParent, onPage, Message, role=1, request='moshaf', onTilaawa}) => {

    const [editable, Edit] = useState('false')
    const [fields, Fields]= useState([])
    const [items, Items]= useState([])
    const [clicked, Clicked] = useState({n:0,x:0,y:0,now:new Date()})
    const [selected, Select] = useState({...entity, parent:0})
    const [style, Style] = useState(null)
    const [loaded, Load] = useState(false)

    const resizer = new meResults(selected.name)
    const [layouts, Layouts]= useState([])
    const [colors, Colors]= useState([])

    useLayoutEffect (()=>{  
        //alert(selected.entity)
        resizer.selectorAll() 

        if(layouts.length>0) {
            layouts.forEach((item) => {
                resizer.SetStyle(item.Name, item.Coord)
            })
        }
        //alert(comments.length)
    })

    useEffect(()=>{
        if(loaded) {
            Load(false)
        }

    },[entity?.parent])

    useEffect(() => {
        if(!loaded || (entity?.parent!==selected.parent) ) {
            Items([])
            const url =  `${request}/${entity.name}/${entity.parent}` 
            //alert(`Table View url=${url} entity=${JSON.stringfy(entity)}`)
            Api.get(url)
            .then(response => {
                if(response.data?.length>0) {
                    Items(response.data)
                    Fields(Object.keys(response.data[0]))
                    Load(true)
                }
            })
            .catch(error => {
                Message && Message(error)
            })
            
            Select({...selected, parent:entity.parent})

            Read(`${request}/Colors/All`,Colors,null,null)

            Read(`/Layout/${entity.name}`,Layouts,null,null)
        }

        if(items?.length>0) {
            //console.log('items',items.length); entity = {...entity, rows:items.length}
            items.forEach(item => {
                item.Checked = false
            })
        }    

    }, [loaded, entity?.parent])

    const Stats = (id=0) => {
        onParent && onParent({rows:items.length, name:entity.name, id})
        
        Etat(`Stats ${entity.name}- Parent=${entity.parent} = ${items.length}`)
    }

    const Etat = (message="") => {
        var etat = document.getElementById("EtatApp")
        if(etat)
            etat.innerHTML = message
    }
    
    const onRefresh = (e) => {
        Load(false)
    }

    const onSize = (e) => {
        //console.log(e, e.src)
        if(e.title==="Minimize") {
            e.title="Maximize"
            e.src=icons.maximize
        }
        else {
            e.title="Minimize"
            e.src=icons.minimize
        }
        //e.reload
        return (e.title==="Minimize") // minimized
    }

    const onAdd = (e) => {
        //alert(`${request} Add ${entity.name} -> ${entity.parent}`)
        if(entity.name.length>2) {
            const data = {
                Entity: entity.name,
                ParentId: entity.parent, 
                Name: `New`
            }
            Fetch(request, data)
            .then(item => {
                Message && Message(`${entity.name} added !`)

                onRefresh(e)
            })
        }
    }

    const onReadOnly = (object, readOnly=true) => {
        //object.readOnly = readOnly
        Edit(readOnly?'false':'true')

        if(readOnly) {
            if(style) {
                object.style = style
            }
        }
        else {
            Style(object.style)
            object.style.cursor = 'text'
            object.style.border = '1px solid blue'
            object.style.backgroundColor = 'rgba(220, 220, 0, 0.5)'
            object.style.fontWeight = 'bold'
            object.focus()
        }
        //console.log(object); alert(`readOnly ${object.readOnly}`)
    }

    useEffect(()=>{
        if(selected?.field)
            Etat(`${selected.name}-Cell : ${selected.field}-${selected.id}=${selected.value}`)
        else
            Etat()

        onChange && onChange(selected)

        //onRefresh()

        if(selected.field==='PageId') {
            onPage && onPage({PageId: selected.value})
            //alert(selected.value)
        }
        if(selected.field==='Tilaawa') {
            onTilaawa && onTilaawa(selected)
            //alert(selected.value)
        }

    }, [selected])

    const onCell = (e, id) => {
        const object = e?.target
        if(object) {
            const field = object.title.substring(0, object.title.indexOf('= '))
            Select({...selected, id:id, field:field, value:object.innerText})

            let cr = object.getBoundingClientRect()
            if(cr && cr.right>0 && cr.bottom>0) {
                let w=parseInt(cr.right-cr.left)
                let h=parseInt(cr.bottom-cr.top)
            
        //let message= `onClick (event x ${event.clientX}, y ${event.clientY})`; console.log(message, cr, clicked)//; Now is debuging 
        
                let n = clicked.n
                let x = parseInt((e.clientX-cr.left)*100/w)||0
                let y = parseInt((e.clientY-cr.top)*100/h)||0
                let now = new Date()
        
                if(Math.abs(clicked.x-x)<3 && Math.abs(clicked.y-y)<3) {
                    let ms=now.getTime()-clicked.now.getTime()
                    if(ms<500) {
                        n=n+1
        
                        if(n>0) {  // 2 or 3 click !

                            onReadOnly(object, false)
                        }
                    }
                    else
                        n=0
                }
                else
                    n=0
                    
                Clicked({n,x,y,now})  
            }
        }
    }

    const toId = (item, index) => {
        const id=`Item-${item.Id}-${fields[index]}`
        return id
    }

    const onCheck = (e, id) => {
        items.filter(item=>{
            return (item.Id===id)
        })
        .map(item => { 
            item.Checked = !item.Checked

            Stats(id)
            Select({...selected, id:id, field:'Id', value:id})
            //return item.Checked
        })

        
        const td = e.target.parentElement
        if(td.tagName==='TD') {
            if (td.classList.contains('checked')) {
                td.classList.remove('checked')
            }
            else {
                td.classList.add('checked') 
            }
        }
    }

    // MeR 241015 ElementsLogs & BridgeSession !
    const Log = (data, object, Message, action="Entity") => {
        Fetch('Log', {...data, action}, object) 
        if(Message) {
            if(action==="Entity")
                Message(`${data?.name}.${data?.id} [${data?.field}] = ${data?.value} !`)
            else if(action==="Component")
                Message(`${data?.component}.${data?.id} [${data?.element}] = ${data?.value} !`)
        }
    }

    const onUpdate = (e, byValue=false) => {
        const object = e?.target
        if(object && editable) {
            const keycode = (e.keyCode ? e.keyCode : e.which)
            //alert(`update ${keycode} - ${e.shiftKey}`)
            if (keycode === 13) {
                if (e.shiftKey) {
        
                }
                else {
                    //alert(`update ${selected.field} ${selected.id} - role=${role}...`)
                    if(role>=1) {
                        object.innerText = object.innerText.slice(0, -2)
                        if (selected?.id > 0) {
                            const data = { ...selected, entity:entity.name, value: object.innerText}
                            Fetch(request, data, object, 'PUT') // object for the update style !
                            .then(res=>{
                                Log(data,object,Message)
                            })
                        }
                    }
                    onReadOnly(object)   
                }
                e.stopPropagation()
            }
            else if (keycode === 27) {
                object.value = object.defaultValue
                onReadOnly(object)
            }		
        }
    }

    const onOption = (e, id) => {
        const object = e?.target
        if(object && id>0 && object.value>0) {
            const field = object.title.substring(0, object.title.indexOf('= '))

            const data = {entity:entity.name, id, field, value: object.value}
            //alert(`update ${request} data=${JSON.stringify(data)}  - role=${role}...`)     
            Fetch(request, data, object, 'PUT') // object for the update style !
            .then(res=>{
                Log(data,object,Message)
                //Fetch('Log', {...data, action: 'Entity'}, object) 
            })
            e.stopPropagation()
        }
    }

    return (
<div className="element" id={`${selected.name}Element`}>
<div className="results-head">   
    <div className="col-sm-9"> 
        <div className="results-name">{entity?.id} - {selected.name}(s)</div>
    </div>   
    <div className="col-sm-1">
        <img className="icons" src={icons.reload} alt="Refresh" onClick={(e) => onRefresh(e)} />
    </div>             
    <div className="col-sm-1">
        <img className="icons" src={icons.add} alt="Create" onClick={(e) => onAdd(e)}/>
    </div>       
    <div className="col-sm-1">
        <img className="icons" src={icons.minimize} alt={"Minimize"} title="Minimize" onClick={(e) => onSize(e)} />
    </div>             
</div>        
        
{ items?.length>0 && fields.length>0
?

<div className="results"
    onMouseDown={(e)=>{resizer.mouseDown(e)}} 
    onMouseMove={(e)=>{resizer.mouseMove(e)}} 
    onMouseUp={(e)=>{resizer.mouseUp(e, Api)}}
>

<table className='styled-table' id={`${selected.name}Table`}>
    
<thead id={`${selected.name}Head`}>
    <tr>
        {
            fields.map(field=>
                <th id={`Th-${field}`} entity={selected.name}>{field}</th>)
        }
    </tr>
</thead>

<tbody id={`${selected.name}Body`}>
{
    items.map(item=>
        <tr key={item.Id}>

{ Object.values(item).map((value,index) => (
    
    index===0 ? (
        <ToId value={value} onClick={e => onCheck(e,value)} checked={item?.Checked} />
    )  : (
        fields[index]?.endsWith('At') ?
        <td style={{textAlign:'right', color:'darkblue'}}>{ToFormat(value)}</td>
        : (
            fields[index]==='ColorId' ?
            <td style={{textAlign:'center'}} id={toId(item,index)} key={toId(item,index)} >
                <ColorsOptions entity={entity.name} item={item} 
                    colors={colors} 
                    title={`${fields[index]}= ${value}`} 
                    onChange={e => {onOption(e, item.Id)}}
                    defaultValue={value} 
                    readOnly={role<2} 
                />
            </td>

        :
        <td className="editable" contentEditable={editable} id={toId(item,index)} key={toId(item,index)}
            title={`${fields[index]}= ${value}`} 
            value={value}
            defaultValue={value}
            onClick={(e) => onCell(e, item.Id)} onKeyUp={e => onUpdate(e)} >
        {value}</td>
        )
    ) 
)) }
    </tr>
            )
}
</tbody>
</table>
</div>

:
<h5>{entity.name} are loading...</h5>
}

<div className="results-foot">
    <div className="col-sm-3">
        <p id="EtatStat">Ready</p>
    </div>

    <div className="col-sm-6">
        <p id="EtatApp">...</p>
    </div>
    <div className="col-sm-3 results-rows">
        <p id="results-rows">{items.length} rows</p>
    </div> 
</div>  

</div>

 )
}

const ToId = ({value, onClick, crud=0, checked}) => {  
    const bstyle = { width: '2rem', display: 'block', padding:'0.2rem', textAlign:'right', border:'none' }  

    const getVariant = () => {
        let bvariant = crud>0 ?  (crud===2 ? "outline-info" : "outline-warning") : "outline-primary"
        if(checked) {
            bvariant = bvariant.replace("outline-","")
        }
        return bvariant
    }
    
    return (
<td className='Id' key={value} value={value} >
    <Button key={`Item-${value}-Id`} value={value} variant={getVariant()} 
        style={bstyle}
        onClick={(e) => onClick(e, value)}
    >{value}</Button>      
</td>
 )
}

export default TableView

